import React from "react";
import styled from "styled-components";
import ActionButton from "../../../elements/ActionButton";

const CloseIdeaButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e3efde;
    min-height: fit-content;
`;


const CloseIdeaButton = ({isLoading, numberOfPortfolios, disabled, onClick}) => {
    return (<CloseIdeaButtonContainer>
        <ActionButton disabled={disabled}
                      isLoading={isLoading}
                      onClick={onClick}
                      className="t-close-idea-button">
            {`Close for ${numberOfPortfolios} portfolio${numberOfPortfolios === 1 ? "" : "s"}`}
        </ActionButton>
    </CloseIdeaButtonContainer>);
};

export default CloseIdeaButton;